import { jsx } from 'react/jsx-runtime';
import { VisuallyHidden } from '@vp/swan';
import { useLocalization } from './ep-pricing-esm-hooks-useLocalizations.js';

const usePriceLabels = (locale) => {
  const { t } = useLocalization(locale);
  const OriginalPriceLabel = /* @__PURE__ */ jsx(VisuallyHidden, { children: t("originalPrice") });
  const SalePriceLabel = /* @__PURE__ */ jsx(VisuallyHidden, { children: t("salePrice") });
  return { OriginalPriceLabel, SalePriceLabel };
};

export { usePriceLabels };
//# sourceMappingURL=ep-pricing-esm-utils-priceLabels.js.map
